<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <p>Usage:</p>
    <div :class="['mt-16']">
      <code>&lt;vc-component v-ripple&gt;...&lt;/vc-component&gt;</code>
    </div>
    <div :class="['mt-16']">
      <code>&lt;div v-ripple&gt;...&lt;/div&gt;</code>
    </div>
    <example-title src="example-1.html" title="Click the components below to observer the ripple effect" />
    <vc-layout :spacing="8">
      <vc-col :span="6" sm12 v-for="i in 4" :key="`0-${i}`" :class="['align-center']">
        <vc-avatar :color="colors[i-1]" :src="`/static/images/avatar-0${i}.png`" :class="['elevation-12']" v-ripple>
        </vc-avatar>
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`1-${i}`" :class="['align-center']">
        <vc-button :color="colors[i-1]">button</vc-button>
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`3-${i}`">
        <vc-text :placeholder="placeholder" v-model="text" :name="`text-${i}`" :color="colors[i-1]" />
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`4-${i}`" :class="['align-center']">
        <vc-icon size="x-large" :color="colors[i-1]" v-ripple>{{ icons[i-1] }}</vc-icon>
      </vc-col>
      <vc-col :span="12" sm12 xs24 v-for="i in 2" :key="`5-${i}`">
        <vc-tabstrip icon-size="normal" :tab-selected="i" :name="`tabstrip-${i}`" :color="colors[4-i]" :tab-height="140">
          <vc-tabstrip-pane :icon="icons[pane]" v-for="pane in 3" :key="pane" :label="`Tab ${pane}`">
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`6-${i}`">
        <vc-checkbox :color="colors[i-1]" v-model="checkbox" :name="`checkbox-${i}`">checkbox {{ i }}</vc-checkbox>
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`7-${i}`">
        <vc-radio-group :name="`guitars-${i}`" :color="colors[i-1]" v-model="mGuitars">
          <vc-radio v-for="(guitar, index) in guitars" :value="guitar" :key="index">{{ guitar }}</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="6" sm12 v-for="i in 4" :key="`2-${i}`" :class="['align-center']">
        <div :class="[colors[i-1], 'pa-16', 'font-white']" v-ripple>(Almost) any other HTML element</div>
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'RipplePage',
  data () {
    return {
      title: null,
      description: null,
      text: null,
      checkbox: false,
      placeholder: 'Focus to observe the ripple',
      mGuitars: 'Jackson',
      guitars: ['Jackson', 'B.C. Rich', 'ESP', 'Epiphone'],
      colors: ['primary', 'orange', 'green', 'pink'],
      icons: ['home', 'schedule', 'info', 'account_circle']
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ripple.vue